import { Link } from 'react-router-dom';
import InsulationCalculator from '../components/InsulationCalculator';
import ReviewSlider from '../components/ReviewSlider';
import { COMPANY_INFO } from '../data/staticData';

export default function InsulationCalculatorPage() {
  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen py-10 sm:py-14">
      <div 
        className="w-full mx-auto px-4 sm:px-6 lg:px-0 space-y-12 sm:space-y-16"
        style={{ width: 'clamp(820px, 62vw, 1180px)', maxWidth: '100%' }}
      >
        
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-xs text-neutral-500 font-['Open_Sans'] pt-2">
          <Link to="/" className="hover:text-[#BE0F12] transition-colors">Forside</Link>
          <span>/</span>
          <Link to="/energiloesninger" className="hover:text-[#BE0F12] transition-colors">Energiløsninger</Link>
          <span>/</span>
          <span className="text-neutral-800 font-semibold">Prisberegner: Isolering</span>
        </div>

        {/* Top Header / Intro Content fra dansktagbyg.dk/p/prisberegner-energiloesninger */}
        <div className="bg-white p-8 sm:p-12 border border-neutral-200 shadow-xs space-y-6">
          <div className="max-w-3xl space-y-4">
            <span className="inline-block px-3 py-1 bg-red-100 text-[#BE0F12] text-xs font-bold uppercase tracking-wider">
              Energiløsninger
            </span>
            <h1 className="font-['Saira'] font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1c1c1c] tracking-tight leading-tight">
              Prøv vores prisberegner på isolering
            </h1>
            <div className="space-y-4 text-stone-700 font-['Open_Sans'] text-base sm:text-lg leading-relaxed">
              <p>
                Vidste du, at det er helt op til 25 % af varmen, der går tabt gennem et dårligt isoleret loft? Med vores simple prisberegner kan du hurtigt og let få en gratis og uforpligtende pris på isolering af dit loft.
              </p>
              <p>
                Husk, at det i nogle tilfælde kan være nødvendigt også at udskifte den eksisterende isolering for at få den bedst mulige reduktion af varmetab gennem loftet på dit hus.
              </p>
              <p className="text-xs sm:text-sm text-stone-500 italic pt-1">
                *Prisen er vejledende, da der er flere faktorer, som spiller ind. Hvis du vil være sikker på at få den helt nøjagtige pris, kan du kontakte os bagefter via kontaktformularen på siden.
              </p>
            </div>
          </div>
        </div>

        {/* Beregner komponent */}
        <InsulationCalculator />

        {/* Informationsafsnit om loftisolering & energibesparelser */}
        <div className="bg-white border border-neutral-200 p-8 sm:p-12 space-y-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            
            <div className="space-y-4">
              <h3 className="font-['Saira'] font-bold text-xl sm:text-2xl text-stone-900 tracking-tight">
                Hvorfor efterisolere loftet?
              </h3>
              <p className="text-stone-600 text-sm sm:text-base leading-relaxed font-['Open_Sans']">
                Varmen stiger opad, og et uisoleret eller utilstrækkeligt isoleret loft er en af de største kilder til varmetab i ældre huse. En efterisolering giver mærkbare fordele fra dag ét:
              </p>
              <ul className="space-y-2.5 text-stone-800 text-sm sm:text-base font-['Open_Sans']">
                <li className="flex items-center gap-3">
                  <i className="fa-solid fa-check text-[#42b732] font-bold"></i>
                  <span>Mærkbar reduktion i den årlige varmeregning</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="fa-solid fa-check text-[#42b732] font-bold"></i>
                  <span>Væsentligt forbedret indeklima uden træk og kulde</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="fa-solid fa-check text-[#42b732] font-bold"></i>
                  <span>Højere energimærke og øget boligværdi ved salg</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="fa-solid fa-check text-[#42b732] font-bold"></i>
                  <span>Lavere CO2-udledning og miljøvenlig bolig</span>
                </li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className="font-['Saira'] font-bold text-xl sm:text-2xl text-stone-900 tracking-tight">
                Hvad skal du være opmærksom på?
              </h3>
              <p className="text-stone-600 text-sm sm:text-base leading-relaxed font-['Open_Sans']">
                Når der lægges ekstra isolering på loftet, ændres temperatur- og fugtforholdene i tagrummet. Derfor skal der altid tages højde for:
              </p>
              <ul className="space-y-2.5 text-stone-800 text-sm sm:text-base font-['Open_Sans']">
                <li className="flex items-center gap-3">
                  <i className="fa-solid fa-circle-check text-[#42b732]"></i>
                  <span>Korrekt ventilation ved tagfod og gavl mod skimmel</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="fa-solid fa-circle-check text-[#42b732]"></i>
                  <span>En intakt og tæt dampspærre</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="fa-solid fa-circle-check text-[#42b732]"></i>
                  <span>Hævning af gangbro og isolering omkring loftslem</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="fa-solid fa-circle-check text-[#42b732]"></i>
                  <span>Professionel udførelse af autoriserede tagfolk</span>
                </li>
              </ul>
            </div>

          </div>

          {/* Kontakt CTA kasse */}
          <div className="pt-8 border-t border-neutral-200 flex flex-col sm:flex-row items-center justify-between gap-6">
            <div>
              <h4 className="font-['Saira'] font-bold text-lg text-stone-900 m-0">
                Vil du have os ud og vurdere dit loftrum?
              </h4>
              <p className="text-xs sm:text-sm text-stone-600 font-['Open_Sans'] mt-1">
                Vi tilbyder et uforpligtende konsulentbesøg, hvor vi måler op og tjekker ventilationen.
              </p>
            </div>
            <div className="flex items-center gap-4 shrink-0">
              <a
                href={COMPANY_INFO.phoneTel}
                className="px-6 py-3 bg-[#BE0F12] hover:bg-[#A30D0F] text-white font-['Saira'] font-bold text-sm uppercase tracking-wider transition-colors shadow-sm flex items-center gap-2"
              >
                <i className="fa-solid fa-phone"></i>
                <span>Ring {COMPANY_INFO.phoneFormatted}</span>
              </a>
              <Link
                to="/kontakt"
                className="px-5 py-3 bg-white hover:bg-neutral-100 border border-neutral-300 text-stone-800 font-['Saira'] font-bold text-sm uppercase tracking-wider transition-colors"
              >
                Kontakt os
              </Link>
            </div>
          </div>

        </div>

        {/* Kundeanmeldelser */}
        <ReviewSlider />

      </div>
    </div>
  );
}
